import { getCurrentUserId } from 'conversations/modules/user/selectors'
import { Message } from 'shared/typings/messages/Message'
import { UserIdType } from 'shared/typings/users/UserIdType'
import { uuidv4 } from 'shared/utils/uuid'

import { GlobalStore as store } from '@driftt/traffic-control'

import { DriftMessage } from './messages/types'

export const PRESEND_KEY = 'presendUUID'

export const getPresendUUID = (message: Message): string | undefined => {
  return message?.attributes?.[PRESEND_KEY]
}

export const findIndexByPresendUUID = (messages?: Message[], presendUUID?: string): number => {
  if (!presendUUID || !messages) {
    return -1
  }
  return messages.findIndex((msg: Message) => getPresendUUID(msg) === presendUUID)
}

interface PresendAttributes {
  uuid: string
  authorId: number
  authorType: UserIdType
  createdAt: number
  attributes: {
    [PRESEND_KEY]: string
    blocks?: DriftMessage
  }
}

export const generatePresendAttributes = (): PresendAttributes => {
  const uuid = uuidv4()

  return {
    uuid,
    authorId: getCurrentUserId(store.getState()) || 0,
    authorType: UserIdType.USER,
    createdAt: new Date().getTime(),
    attributes: {
      [PRESEND_KEY]: uuid,
    },
  }
}
